// extracted by mini-css-extract-plugin
export default {"legend":"IdlesStackedBarsLegend_legend__wuYzL"};